module.exports = __webpack_public_path__ + "img/archer_small.3606d54f.png";